import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';
import {
    AccountBalanceWallet,
    Gavel,
    CheckCircle,
    ReportProblem,
    Group,
    NoteAlt,
    Send,
    Calculate,
    TrendingUp,
    Close,
    MenuBook,
    ReceiptLong
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)} startIcon={<Close />}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアとお金の貸し借り問題：はじめに
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-cases')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    金銭トラブルのよくある事例
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('rule-making')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルール作りと記録の重要性
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('warikan-apps')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    割り勘アプリの活用術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('trouble-solution')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    トラブルが起きた時の対処法
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめとアドバイス
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                    startIcon={<MenuBook />}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入 */}
            <Box id="introduction" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアとお金の貸し借り問題：はじめに
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    近年、ルームシェアは多様なライフスタイルやコストパフォーマンスを求める人々にとって、ますます身近な選択肢となっています。しかし、共同生活には楽しさだけでなく、思わぬトラブルもつきもの。特に「お金の貸し借り」は些細なきっかけで信頼関係が揺らぐ原因となりやすく、ルームシェア解消の引き金になることも少なくありません。
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    本記事では、実際に起こりがちな金銭トラブルの事例から、トラブルを未然に防ぐルール作りや記録のコツ、割り勘アプリの活用方法、万が一トラブルが起こった場合の対処法まで、具体的かつ実践的なノウハウを分かりやすく解説します。これからルームシェアを始めたい方も、すでに生活を共にしている方も、ぜひ参考にしてみてください。
                </Typography>
                <Box sx={{ my: 3, textAlign: 'center' }}>
                    <img
                        src="/images/blog/share-living-dinner_roomshare-money-trouble-prevention.jpg"
                        alt="明るい共有リビングで多様なルームメイトたちがテーブルを囲み、カラフルな料理をシェアしながら和やかに談笑する様子。部屋の雰囲気は温かく親しみやすく、ルームシェアならではの共同生活の楽しさと信頼感を表現している。"
                        style={{ width: '100%', maxWidth: 600, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.07)' }}
                    />
                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                        ルームシェアの共同生活は楽しい反面、金銭トラブルのリスクも。信頼を守る工夫が大切です。
                    </Typography>
                </Box>
            </Box>

            {/* 金銭トラブルのよくある事例 */}
            <Box id="trouble-cases" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    金銭トラブルのよくある事例
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <AccountBalanceWallet sx={{ color: '#1976d2', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    家賃・光熱費の立替え未払い
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「今月だけ払っておいて」「来月まとめて返すから」といった口約束が重なり、立替えた側が返金されないまま関係が悪化するケース。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ReceiptLong sx={{ color: '#1976d2', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    共同購入や食費の割り勘のズレ
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                日用品や食材などを「今度まとめて清算しよう」と後回しにした結果、誰がいくら支払ったか分からなくなり、もめ事に発展。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <ReportProblem sx={{ color: '#1976d2', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    少額の立替えの積み重ね
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                「コーヒー代」「洗剤代」など小さな立替えが積もり積もって、精算が曖昧になり不公平感が増してしまうパターン。
                            </Typography>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Gavel sx={{ color: '#1976d2', mr: 1 }} />
                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                    トラブル後の関係悪化・退去問題
                                </Typography>
                            </Box>
                            <Typography variant="body2">
                                金銭トラブルがこじれて信頼関係が崩壊し、ルームシェアを解消せざるを得なくなることもあります。
                            </Typography>
                        </Paper>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    金銭トラブルは小さな違和感から始まり、時に生活全体を揺るがす大きな問題に発展します。未然に防ぐための工夫が欠かせません。
                </Typography>
            </Box>

            {/* ルール作りと記録の重要性 */}
            <Box id="rule-making" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルール作りと記録の重要性
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    金銭トラブルを防ぐ第一歩は、「ルールを作ること」と「記録を残すこと」。どちらも面倒に感じるかもしれませんが、ちょっとした約束ごとや習慣が、大きな安心感と信頼につながります。
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <img
                        src="/images/blog/roommate-meeting_roomshare-money-trouble-prevention.jpg"
                        alt="シックなダイニングテーブルでルームメイトたちがノートPCやメモ帳を前に話し合い、共同生活のルール作りについて真剣に議論している様子。空間は落ち着いた色調で、円滑なコミュニケーションを象徴している。"
                        style={{ width: '100%', maxWidth: 600, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.07)' }}
                    />
                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                        ルームメイト同士での定期的な話し合いは、金銭トラブル予防の第一歩です。
                    </Typography>
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, display: 'flex', alignItems: 'center' }}>
                    <NoteAlt sx={{ mr: 1, color: '#43a047' }} />
                    具体的なルール例
                </Typography>
                <List sx={{ pl: 1, mb: 3 }}>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText
                            primary="家賃や光熱費は毎月●日までに指定口座へ振り込み"
                            secondary="支払い期日と方法を明文化しておく"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText
                            primary="立替えは必ずグループLINEやチャットで共有"
                            secondary="誰が・何を・いくら立て替えたか記録を残す"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText
                            primary="精算は毎月●日、必ず全員で確認"
                            secondary="まとめて清算する習慣をつける"
                        />
                    </ListItem>
                </List>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                    ルールは「見える化」が重要。紙やホワイトボード、共有ドキュメントなどを活用して誰もが確認できるようにしましょう。
                </Typography>
                <Box sx={{ bgcolor: '#f5f5f5', borderRadius: 2, p: 2, my: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1976d2', mb: 0.5 }}>
                        専門家のポイント
                    </Typography>
                    <Typography variant="body2">
                        実際のトラブル相談では、「言った・言わない」や「記憶違い」が原因となることが非常に多いです。些細なことでも必ず記録を残す習慣が、信頼と安心を守る最大のコツです。
                    </Typography>
                </Box>
            </Box>

            {/* 割り勘アプリの活用術 */}
            <Box id="warikan-apps" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    割り勘アプリの活用術
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    最近では、立替えや割り勘の煩雑さを解消する便利なアプリが充実しています。スマホ一つで記録・精算ができるので、ルームシェア生活の必需品とも言える存在です。
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <img
                        src="/images/blog/warikan-app_roomshare-money-trouble-prevention.jpg"
                        alt="スマートフォン画面に割り勘アプリの精算画面が表示され、複数人のアイコンと支払い履歴がわかりやすく並んでいる。明るくモダンな雰囲気のテーブルの上にスマホが置かれ、手軽さと便利さが表現されている。"
                        style={{ width: '100%', maxWidth: 400, borderRadius: 10, boxShadow: '0 4px 12px rgba(0,0,0,0.07)' }}
                    />
                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                        割り勘アプリを活用すれば、煩雑な計算や記録もスマートに管理できます。
                    </Typography>
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, display: 'flex', alignItems: 'center' }}>
                    <Calculate sx={{ mr: 1, color: '#0097a7' }} />
                    人気の割り勘アプリ
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ maxWidth: 280, borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ color: '#1976d2', mb: 1 }}>
                                    LINE Pay
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    チャット感覚で割り勘記録・送金・リマインダーができて便利。ルームメイトとの日常連絡にも最適。
                                </Typography>
                                <Chip label="無料" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="送金機能" color="primary" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ maxWidth: 280, borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ color: '#43a047', mb: 1 }}>
                                    groupay
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    割り勘の定番アプリ。誰がどれだけ支払ったかをグループで管理し、精算履歴も一目瞭然。
                                </Typography>
                                <Chip label="多人数" color="success" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="履歴保存" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card sx={{ maxWidth: 280, borderRadius: 2 }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ color: '#f9a825', mb: 1 }}>
                                    PayPay
                                </Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    キャッシュレス派にオススメ。送金や割り勘機能が充実し、気軽に少額の精算も可能。
                                </Typography>
                                <Chip label="キャッシュレス" color="warning" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="即時送金" color="warning" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Divider sx={{ my: 3 }} />
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                    アプリ選びのポイントは「全員が使いやすいこと」と「記録が残ること」。導入前にルームメイト全員で使い方を確認しましょう。
                </Typography>
                <Box sx={{ bgcolor: '#e3f2fd', borderRadius: 2, p: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#0097a7', mb: 0.5 }}>
                        専門家のワンポイント
                    </Typography>
                    <Typography variant="body2">
                        立替えや精算を「アプリで即記録・即精算」する習慣が身につくと、そもそもトラブルの芽が生まれにくくなります。
                    </Typography>
                </Box>
            </Box>

            {/* トラブル時の対処法 */}
            <Box id="trouble-solution" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    トラブルが起きた時の対処法
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    どれだけ気をつけていても、時にはトラブルが発生してしまうことも。そんな時、感情的にならず、冷静に対処することが解決への近道です。
                </Typography>
                <Box sx={{ mb: 2 }}>

                    <Typography variant="caption" sx={{ display: 'block', mt: 1, color: 'text.secondary' }}>
                        トラブル発生時は感情を抑え、事実を整理して話し合うことが大切です。
                    </Typography>
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1, display: 'flex', alignItems: 'center' }}>
                    <Group sx={{ mr: 1, color: '#1976d2' }} />
                    トラブル対応のステップ
                </Typography>
                <List sx={{ pl: 1 }}>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><NoteAlt color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="まずは記録や履歴を確認"
                            secondary="支払い履歴やメッセージなど客観的な事実を整理"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><Send color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="冷静な話し合いを設ける"
                            secondary="「責める」ではなく「事実確認と解決策の提案」を意識"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><TrendingUp color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="解決策を合意し、必ず記録に残す"
                            secondary="返済方法・期日などを書面やチャットで共有"
                        />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><Gavel color="primary" /></ListItemIcon>
                        <ListItemText
                            primary="第三者の相談窓口を活用"
                            secondary="どうしても解決困難な場合は友人や法的機関など信頼できる第三者に相談"
                        />
                    </ListItem>
                </List>
                <Box sx={{ bgcolor: '#ffe082', borderRadius: 2, p: 2, mt: 2 }}>
                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#f9a825', mb: 0.5 }}>
                        注意ポイント
                    </Typography>
                    <Typography variant="body2">
                        感情的なやり取りや、口約束だけでの解決はトラブルを長引かせる原因となります。「事実」と「記録」を軸に、誠実な対話を心がけましょう。
                    </Typography>
                </Box>
            </Box>

            {/* まとめとアドバイス */}
            <Box id="summary" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめとアドバイス
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでの「お金の貸し借り」トラブルは、ちょっとした油断や遠慮から生まれがちです。しかし、ルール作り・記録・アプリ活用といった小さな工夫の積み重ねが、安心で快適な共同生活を支えてくれます。
                </Typography>
                <Box sx={{ mb: 2 }}>
                    <Chip label="ルール" color="primary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="記録" color="secondary" variant="outlined" sx={{ mr: 1 }} />
                    <Chip label="割り勘アプリ" color="success" variant="outlined" />
                </Box>
                <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                    最後にチェック！
                </Typography>
                <List sx={{ pl: 1 }}>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="毎月の支払いルール、明文化できていますか？" />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="立替えや割り勘は必ず記録を残す習慣を！" />
                    </ListItem>
                    <ListItem sx={{ pl: 0 }}>
                        <ListItemIcon><CheckCircle color="success" /></ListItemIcon>
                        <ListItemText primary="トラブル時は冷静な話し合いと事実確認を徹底！" />
                    </ListItem>
                </List>
                <Box sx={{ bgcolor: '#e3f2fd', borderRadius: 2, p: 2, mt: 2 }}>
                    <Typography variant="body2" sx={{ color: '#1976d2', fontWeight: 'bold', mb: 0.5 }}>
                        共同生活の最大の財産は「信頼」
                    </Typography>
                    <Typography variant="body2">
                        お金のトラブルは、信頼を損なうだけでなく、せっかくの楽しいルームシェア生活そのものを台無しにしてしまうこともあります。日ごろからの小さな配慮と工夫で、誰もが笑顔で過ごせる共同生活を築いていきましょう。
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-money-trouble-prevention',
    slug: 'roomshare-money-trouble-prevention',
    title: 'ルームシェアでの「お金の貸し借り」トラブルを防ぐ方法',
    excerpt: '金銭トラブル事例\nルール作りと記録\n割り勘アプリ\nトラブル時の対処法',
    coverImage: '/images/blog/cover-roomshare-money_roomshare-money-trouble-prevention.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。共同生活の温かさと信頼感、快適な暮らしの雰囲気を伝える写真で、記事のテーマであるお金のトラブル防止の重要性も表現されている。',
    publishedAt: '2024-06-21T09:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', 'トラブル対策', 'お金と生活'],
    tags: ['ルームシェア', '金銭トラブル', '割り勘アプリ'],
    author: {
        name: '石田 良太',
        avatar: '/images/avatars/ishida.jpg',
        bio: 'ルームシェア・シェアハウスの運営・相談実績多数。多様なライフスタイルと快適な共同生活の実現をサポートするアドバイザー。トラブル予防や住まい選びの専門知識を活かした発信を行う。',
        profilePicture: '/images/avatars/ishida-profile.jpg'
    },
    viewCount: 1023,
    contentComponent: PostContent
};

export default post;